let desktopLoginToggleStatus = false;
let desktopLanguageDropdownExpanded = false;

export function handleMainMenu() {
  const hamburger = document.querySelector(".pul-hamburger");
  if (!hamburger) return;

  const login = document.querySelector(".pul-login");
  const mobileLogin = document.querySelector(".pul-menu-list-actions [aria-controls='pul-menu-login']");
  const loginBackBtn = document.querySelector(".pul-menu-login .pul-back-link");
  const desktopLangDropdown = document.querySelector(".pul-lang button");

  hamburger.addEventListener("click", () =>
    toggleHamburger(hamburger, login, hamburger.getAttribute("aria-controls"))
  );

  login?.addEventListener("click", () =>
    toggleLogin(login, hamburger, login.getAttribute("aria-controls"))
  );

  mobileLogin?.addEventListener("click", handleMobileLogin);

  loginBackBtn?.addEventListener("click", () => {
    loginBackBtn.blur();
    handleLoginBack(hamburger, login);
  });

  desktopLangDropdown?.addEventListener("click", () => toggleDesktopLanguageDropdown(desktopLangDropdown));

  goToNextLvl();
  goToPrevLvl();

  // Close desktop language selector when clicking outside
  document.addEventListener("click", (e) => {
    if (desktopLanguageDropdownExpanded && !desktopLangDropdown.contains(e.target)) {
      desktopLangDropdown.setAttribute("aria-expanded", "false");
      desktopLanguageDropdownExpanded = false;
    }
  });
}

function toggleHamburger(hamburger, login, targetId) {
  const targetEl = document.getElementById(targetId);
  const isExpanded = hamburger.getAttribute("aria-expanded") === "true";

  if (!isExpanded) {
    hamburger.setAttribute("aria-expanded", "true");
    hamburger.setAttribute("data-open", "true");
    targetEl?.setAttribute("aria-hidden", "false");
  } else {
    hamburger.setAttribute("aria-expanded", "false");
    hamburger.removeAttribute("data-open");
    targetEl?.setAttribute("aria-hidden", "true");
  }

  // If login is open while hamburger is open, remove the data-open attribute.
  if (login?.getAttribute("aria-expanded") === "true" && hamburger.getAttribute("data-open") === "true") {
    hamburger.removeAttribute("data-open");
  }

  toggleMenu();
}

function toggleLogin(login, hamburger, targetId) {
  const menu = document.querySelector(".pul-navigation__menu-list");
  const navigation = document.querySelector(".pul-main-menu");
  const htmlElement = document.documentElement;
  const targetEl = document.getElementById(targetId);
  if (!menu || !navigation || !targetEl) return;

  const isLoginHidden = targetEl.getAttribute("aria-hidden") === "true";
  const isHamburgerExpanded = hamburger.getAttribute("aria-expanded") === "true";
  const isDataOpenNull = hamburger.getAttribute("data-open") === null;

  // Open login menu when all conditions meet
  if (isLoginHidden && !isHamburgerExpanded && isDataOpenNull && !desktopLoginToggleStatus) {
    login.setAttribute("aria-expanded", "true");
    targetEl.setAttribute("aria-hidden", "false");
    menu.classList.add("open");
    desktopLoginToggleStatus = true;
    setTimeout(() => {
      menu.classList.add("fade-in");
      htmlElement.classList.remove("locked");
      htmlElement.style.paddingInlineEnd = "0";
      hamburger.setAttribute("data-open", "true");
    }, 10);
  }
  // Close login menu when already open
  else if (!isLoginHidden && !isHamburgerExpanded && isDataOpenNull && desktopLoginToggleStatus) {
    login.setAttribute("aria-expanded", "false");
    targetEl.setAttribute("aria-hidden", "true");
    menu.classList.remove("fade-in");
    setTimeout(() => {
      menu.classList.remove("open");
      htmlElement.classList.remove("locked");
      htmlElement.style.paddingInlineEnd = "0";
      desktopLoginToggleStatus = false;
      hamburger.removeAttribute("data-open");
    }, 310);
  }
  // Close login when clicked again on the icon during main menu open
  else if (
    !isLoginHidden &&
    navigation.getAttribute("aria-hidden") === "true" &&
    hamburger.getAttribute("data-open") === "true"
  ) {
    login.setAttribute("aria-expanded", "false");
    targetEl.setAttribute("aria-hidden", "true");
    hamburger.removeAttribute("data-open");
    menu.classList.remove("fade-in");
    setTimeout(() => {
      menu.classList.remove("open");
      htmlElement.classList.remove("locked");
      htmlElement.style.paddingInlineEnd = "0";
      desktopLoginToggleStatus = false;
      resetMenuState();
    }, 310);
  }
  // Open login while main menu is active
  else if (hamburger.getAttribute("data-open") === "true") {
    resetMenuState();
    if (login.getAttribute("aria-expanded") === "false") {
      login.setAttribute("aria-expanded", "true");
      targetEl.setAttribute("aria-hidden", "false");
      desktopLoginToggleStatus = false;
    }
  }
}

function toggleMenu() {
  const menu = document.querySelector(".pul-navigation__menu-list");
  const firstLevel = menu?.querySelector(".pul-main-menu-lvl-1");
  const navLevels = menu?.querySelectorAll(".pul-main-menu-lvl");
  const htmlElement = document.documentElement;
  if (!menu || !firstLevel) return;

  if (menu.classList.contains("open")) {
    menu.classList.remove("fade-in");
    setTimeout(() => {
      menu.classList.remove("open");
      htmlElement.classList.remove("locked");
      htmlElement.style.paddingInlineEnd = "0";
    }, 310);
    navLevels?.forEach(level => level.classList.remove("active"));
    resetMenuState();
  } else {
    htmlElement.style.paddingInlineEnd = `${handlePageShift()}px`;
    htmlElement.classList.add("locked");
    menu.classList.add("open");
    firstLevel.classList.add("active");
    setTimeout(() => {
      menu.classList.add("fade-in");
    }, 10);
  }
}

function goToNextLvl() {
  const triggers = document.querySelectorAll(".pul-main-menu-lvl [aria-controls]");
  const expandedArias = document.querySelectorAll(".pul-main-menu-lvl-2 [aria-expanded]");
  triggers.forEach(trigger => {
    trigger.addEventListener("click", () => {
      // Collapse all expanded items
      expandedArias.forEach(btn => btn.setAttribute("aria-expanded", "false"));

      const targetEl = document.getElementById(trigger.getAttribute("aria-controls"));
      collapseSiblings(trigger);

      if (targetEl) {
        document.querySelectorAll(".pul-main-menu-lvl.active").forEach(lvl => lvl.classList.remove("active"));
        targetEl.setAttribute("aria-hidden", "false");
        targetEl.parentElement.classList.add("active");
        targetEl.querySelector("a").focus();
        trigger.setAttribute("aria-expanded", "true");
      }
    });
  });
}

function goToPrevLvl() {
  const backLinks = document.querySelectorAll(".pul-main-menu-lvl .pul-back-link");
  backLinks.forEach(link => {
    const parentLevel = link.closest(".pul-main-menu-lvl");
    link.addEventListener("click", () => {
      link.closest("[aria-hidden]")?.setAttribute("aria-hidden", "true");
      parentLevel?.classList.remove("active");
      const prevLevel = parentLevel?.previousElementSibling;
      prevLevel?.classList.add("active");
      prevLevel?.querySelector("[aria-expanded='true']")?.setAttribute("aria-expanded", "false");
    });
  });
}

function collapseSiblings(trigger) {
  if (trigger.closest("div.pul-main-menu-lvl-1")) {
    document.querySelectorAll(".pul-main-menu-lvl-1 [aria-expanded='true']")
      .forEach(el => el.setAttribute("aria-expanded", "false"));
    document.querySelectorAll(".pul-main-menu-lvl-2 [aria-hidden='false']")
      .forEach(el => el.setAttribute("aria-hidden", "true"));
    document.querySelectorAll(".pul-main-menu-lvl-3 [aria-hidden='false']")
      .forEach(el => el.setAttribute("aria-hidden", "true"));
  }
  if (trigger.closest("div.pul-main-menu-lvl-2")) {
    document.querySelectorAll(".pul-main-menu-lvl-2 [aria-expanded='true']")
      .forEach(el => el.setAttribute("aria-expanded", "false"));
    document.querySelectorAll(".pul-main-menu-lvl-3 [aria-hidden='false']")
      .forEach(el => el.setAttribute("aria-hidden", "true"));
  }
}

function handleMobileLogin() {
  const activeLevel = document.querySelector(".pul-main-menu-lvl.active");
  const expandedAreas = document.querySelectorAll(".pul-main-menu-lvl [aria-expanded]");
  const hiddenAreas = document.querySelectorAll(".pul-main-menu-lvl [aria-hidden]");

  document.querySelector(".pul-main-menu")?.setAttribute("aria-hidden", "true");
  activeLevel?.classList.remove("active");

  expandedAreas.forEach(el => el.setAttribute("aria-expanded", "false"));
  hiddenAreas.forEach(el => el.setAttribute("aria-hidden", "true"));

  document.querySelector(".pul-menu-login")?.setAttribute("aria-hidden", "false");
}

function handleLoginBack(hamburger, login) {
  const firstLevel = document.querySelector(".pul-main-menu-lvl-1");
  document.querySelector(".pul-menu-login")?.setAttribute("aria-hidden", "true");
  document.querySelector(".pul-main-menu")?.setAttribute("aria-hidden", "false");
  firstLevel?.classList.add("active");

  hamburger.setAttribute("aria-expanded", "true");
  hamburger.setAttribute("data-open", "true");
  login.setAttribute("aria-expanded", "false");
}

function resetMenuState() {
  document.querySelectorAll(".pul-navigation [aria-expanded]").forEach(el =>
    el.setAttribute("aria-expanded", "false")
  );
  document.querySelectorAll(".pul-navigation [aria-hidden]").forEach(el =>
    el.setAttribute("aria-hidden", "true")
  );
}

function handlePageShift() {
  return window.innerWidth - document.documentElement.clientWidth;
}

function toggleDesktopLanguageDropdown(button) {
  desktopLanguageDropdownExpanded = !desktopLanguageDropdownExpanded;
  button.setAttribute("aria-expanded", desktopLanguageDropdownExpanded ? "true" : "false");
}
